// Pure helpers for the retention curve, apart from the component so fast refresh keeps working.

export interface RetentionChartPoint {
  /** How far into the video, 0 (start) → 1 (end). */
  position: number;
  /** Share of viewers still watching there, 0 → 1. */
  retained: number;
}

/** "0:07" — or "35%" through the video when the length is unknown. */
export function retentionAt(position: number, durationSeconds?: number | null): string {
  if (durationSeconds && durationSeconds > 0) {
    const s = Math.max(0, Math.round(position * durationSeconds));
    return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
  }
  return `${Math.round(position * 100)}%`;
}

/** The pair of neighbouring points with the largest fall — the moment the analysis is asked to explain. */
export function steepestDrop(points: ReadonlyArray<RetentionChartPoint>): { from: RetentionChartPoint; to: RetentionChartPoint } | null {
  let best: { from: RetentionChartPoint; to: RetentionChartPoint } | null = null;
  for (let i = 1; i < points.length; i++) {
    const fall = points[i - 1].retained - points[i].retained;
    if (fall > 0.01 && (!best || fall > best.from.retained - best.to.retained)) best = { from: points[i - 1], to: points[i] };
  }
  return best;
}
